import { DynamicViewData } from "src/dynamic-view-renderer/DynamicViewRenderer.typings";
import { DashboardWidgetConfiguration } from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider.types";
import { PrintableAlertWorkflowWidget } from "src/dynamic-view-renderer/PrintableWidgets/PrintableAlertWorkflowWidget";
import { PrintableBasicWidget } from "src/dynamic-view-renderer/PrintableWidgets/PrintableBasicWidget";
import { PrintableChronologyWidget } from "src/dynamic-view-renderer/PrintableWidgets/PrintableChronologyWidget";
import { PrintableRelatedCasesWidget } from "src/dynamic-view-renderer/PrintableWidgets/PrintableRelatedCasesWidget";
import { PrintableRulesWidget } from "src/dynamic-view-renderer/PrintableWidgets/PrintableRulesWidget";
import { PrintableWidgetContainer } from "src/dynamic-view-renderer/PrintableWidgets/PrintableWidgetContainer";
import { DEFAULT_MAX_RELATED_CASES } from "src/dynamic-view-renderer/Views/PrintableView/printableView.utils";
import { useT } from "src/internationalization";
import { ClientSchema } from "src/types/clientSchema";

import { RelatedWidgetConfiguration } from "../Widgets/RelatedCases/relatedCases.typings";
import { WidgetDefinition } from "../Widgets/Widget.typings";

export function PrintableWidgetRenderer({
  definition,
  config,
  data,
  caseSchema,
}: {
  definition: WidgetDefinition;
  config: DashboardWidgetConfiguration;
  data: DynamicViewData;
  caseSchema: ClientSchema;
}) {
  const widgets = data.widgetsData;
  const t = useT();
  let content;
  switch (definition.type) {
    case "table":
      content = (
        <PrintableRelatedCasesWidget
          data={widgets.relatedCases}
          configuration={
            definition.configuration?.customConfiguration as RelatedWidgetConfiguration
          }
          maxRelatedCases={config.maxRelatedCases ?? DEFAULT_MAX_RELATED_CASES}
        />
      );
      break;
    case undefined:
    case "basic":
      content = (
        <PrintableBasicWidget
          definition={definition}
          data={widgets.basic}
          caseSchema={caseSchema}
        />
      );
      break;
    case "rules":
      content = (
        <PrintableRulesWidget
          execution={widgets.rules?.scenarioExecutionResult}
          manual={widgets.origin === "manual"}
        />
      );
      break;
    case "alertWorkflow":
      content = widgets.alertWorkflow?.alert ? (
        <PrintableAlertWorkflowWidget alert={widgets.alertWorkflow.alert} />
      ) : (
        <p>{t("page.alert.pdf.workflow.unavailable")}.</p>
      );
      break;
    case "chronology":
      content = widgets.chronology?.alert ? (
        <PrintableChronologyWidget alert={widgets.chronology.alert} />
      ) : (
        <p>{t("page.alert.pdf.chronology.unavailable")}.</p>
      );
      break;
    default:
      content = (
        <p role="alert">
          {t("page.alert.pdf.printable.unavailable")} : {definition.type}
        </p>
      );
  }
  return (
    <PrintableWidgetContainer definition={definition} pageBreakBefore={config.printPageBreakBefore}>
      {content}
    </PrintableWidgetContainer>
  );
}
